import { graphql } from '@contra/relay';

export const appPreloadQuery = graphql`
  query AppPreloadQuery {
    visitor {
      ...AppPreload_visitor
    }
  }
`;
